:root {
    font-family: 'InterORP', sans-serif;
    --font-family: 'InterORP', sans-serif;
}

button,
input,
select,
textarea {
    font-family: inherit;
}

@font-face {
    font-family: 'InterORP';
    src: url('/fonts/Inter-Thin.ttf');
    font-weight: 100;
    font-style: normal;
}
@font-face {
    font-family: 'InterORP';
    src: url('/fonts/Inter-ExtraLight.ttf');
    font-weight: 200;
    font-style: normal;
}
@font-face {
    font-family: 'InterORP';
    src: url('/fonts/Inter-Light.ttf');
    font-weight: 300;
    font-style: normal;
}
@font-face {
    font-family: 'InterORP';
    src: url('/fonts/Inter-Regular.ttf');
    font-weight: 400;
    font-style: normal;
}
@font-face {
    font-family: 'InterORP';
    src: url('/fonts/Inter-Medium.ttf');
    font-weight: 500;
    font-style: normal;
}
@font-face {
    font-family: 'InterORP';
    src: url('/fonts/Inter-SemiBold.ttf');
    font-weight: 600;
    font-style: normal;
}
@font-face {
    font-family: 'InterORP';
    src: url('/fonts/Inter-Bold.ttf');
    font-weight: 700;
    font-style: normal;
}
@font-face {
    font-family: 'InterORP';
    src: url('/fonts/Inter-ExtraBold.ttf');
    font-weight: 800;
    font-style: normal;
}
@font-face {
    font-family: 'InterORP';
    src: url('/fonts/Inter-Black.ttf');
    font-weight: 900;
    font-style: normal;
}

/* Global styles for the prime react components */
.p-multiselect-panel .p-multiselect-item {
    font-size: 12px;
}

.p-multiselect-header {
    display: none;
}

.p-button {
    font-size: 14px;
    padding: 10px 20px;
    height: 40px;
    box-sizing: border-box;
}

.p-button .p-button-label {
    font-size: 14px;
}

.p-button .p-button-icon {
    font-size: 14px;
}

.p-button.p-button-info:not(.p-button-outlined):not(.p-button-text) {
    background: #2679ad;
    border-color: #2679ad;
}

.p-button.p-button-info:not(.p-button-outlined):not(.p-button-text):not(:disabled):hover,
.p-button.p-button-info:not(.p-button-outlined):not(.p-button-text):not(:disabled):focus {
    background: #1f6492;
    border-color: #1f6492;
}

.p-button.p-button-info.p-button-outlined,
.p-button.p-button-secondary.p-button-outlined {
    color: #2679ad;
    border-color: #2679ad;
    background: transparent;
}

.p-button.p-button-info.p-button-outlined:not(:disabled):hover,
.p-button.p-button-info.p-button-outlined:not(:disabled):focus,
.p-button.p-button-secondary.p-button-outlined:not(:disabled):hover,
.p-button.p-button-secondary.p-button-outlined:not(:disabled):focus {
    background: rgba(38, 121, 173, 0.04);
    color: #1f6492;
    border-color: #1f6492;
}

.p-button.p-button-success:not(.p-button-outlined):not(.p-button-text) {
    background: #059669;
    border-color: #059669;
}

.p-button.p-button-success:not(.p-button-outlined):not(.p-button-text):not(:disabled):hover,
.p-button.p-button-success:not(.p-button-outlined):not(.p-button-text):not(:disabled):focus {
    background: #047857;
    border-color: #047857;
}
